<template>
  <button
    v-if="temPermissaoMensagem"
    id="header-notificacoes-nav-mobile"
    type="button"
    class="header-notificacoes-mobile"
    :class="{
      'noti-nav--tour': tourNotificacoesAtivo,
      'header-notificacoes-mobile--app': layoutAppNativo,
    }"
    :title="contagemBadgeTotalTitulo"
    :aria-label="contagemBadgeTotalTitulo"
    @click="aoClicar"
  >
    <span class="notification-icon-wrap">
      <img
        src="../assets/img/icon/notification.svg"
        alt=""
        class="notification-icon"
        :class="{ 'notification-icon--pulse': temNova, 'notification-icon--muted': !temNova }"
      >
      <span
        v-if="contagemBadgeTotal"
        class="notification-badge notification-badge--total"
      >{{ contagemBadgeTotal }}</span>
    </span>
  </button>
</template>

<script>
import userService from '../helpers/user.service'
import eventBus from '../helpers/event.bus'
import notificacaoCacheService from '../helpers/notificacao.cache.service'
import { router } from '../router'
import { isNativePlatform } from '../helpers/platform.url.service'
import {
  TOUR_NOTIFICACOES_ENCERRAR,
  TOUR_NOTIFICACOES_PREPARAR_MOBILE,
} from '../helpers/helper.notificacao.tour'

export default {
  name: 'HeaderNotificacoesMobile',
  data() {
    return {
      Mensagens: null,
      Notificacoes: null,
      temNova: false,
      tourNotificacoesAtivo: false,
      onMensagensNotificacao: null,
      onTourPrepararMobile: null,
      onTourEncerrar: null,
    }
  },
  computed: {
    layoutAppNativo() {
      return isNativePlatform()
    },
    temPermissaoMensagem() {
      if (!userService.isAuthenticated())
        return false
      return userService.checkPermision('Mensagem')
    },
    contagemNaoLidasTotal() {
      const mensagens = parseInt(this.Mensagens, 10) || 0
      const notificacoes = parseInt(this.Notificacoes, 10) || 0
      return mensagens + notificacoes
    },
    contagemBadgeTotal() {
      return this.formatarContagemBadge(this.contagemNaoLidasTotal)
    },
    contagemBadgeTotalTitulo() {
      const mensagens = parseInt(this.Mensagens, 10) || 0
      const notificacoes = parseInt(this.Notificacoes, 10) || 0
      const partes = []
      if (mensagens > 0)
        partes.push(this.$t('header.unreadMessages', { count: mensagens }))
      if (notificacoes > 0)
        partes.push(this.$t('header.unreadNotifications', { count: notificacoes }))
      return partes.join(' · ') || this.$t('header.noNotifications')
    },
  },
  mounted() {
    this.aplicarCacheInicial()

    this.onMensagensNotificacao = (event) => this.receberMensagensNotificacao(event)
    eventBus.addEventListener(notificacaoCacheService.EVENTO_CONTAGENS_NOTIFICACAO, this.onMensagensNotificacao)

    this.onTourPrepararMobile = () => {
      this.tourNotificacoesAtivo = true
    }
    this.onTourEncerrar = () => {
      this.tourNotificacoesAtivo = false
    }
    eventBus.addEventListener(TOUR_NOTIFICACOES_PREPARAR_MOBILE, this.onTourPrepararMobile)
    eventBus.addEventListener(TOUR_NOTIFICACOES_ENCERRAR, this.onTourEncerrar)
  },
  beforeUnmount() {
    if (this.onMensagensNotificacao)
      eventBus.removeEventListener(notificacaoCacheService.EVENTO_CONTAGENS_NOTIFICACAO, this.onMensagensNotificacao)
    if (this.onTourPrepararMobile)
      eventBus.removeEventListener(TOUR_NOTIFICACOES_PREPARAR_MOBILE, this.onTourPrepararMobile)
    if (this.onTourEncerrar)
      eventBus.removeEventListener(TOUR_NOTIFICACOES_ENCERRAR, this.onTourEncerrar)
  },
  methods: {
    formatarContagemBadge(valor) {
      const n = parseInt(valor, 10)
      if (!Number.isFinite(n) || n <= 0)
        return null
      return n > 99 ? '99+' : String(n)
    },
    aplicarCacheInicial() {
      const cache = notificacaoCacheService.lerNotificacoesCache()
      if (!cache)
        return
      this.Mensagens = cache.mensagens
      this.Notificacoes = cache.notificacoes
      this.temNova = cache.mensagens > 0 || cache.notificacoes > 0
    },
    receberMensagensNotificacao(event) {
      const mensagens = event.detail?.mensagens ?? 0
      const notificacoes = event.detail?.notificacoes ?? 0
      this.Mensagens = mensagens
      this.Notificacoes = notificacoes
      this.temNova = mensagens > 0 || notificacoes > 0
    },
    async aoClicar() {
      try {
        await notificacaoCacheService.obterContagensNaoLidas({ forcar: true })
      } catch {
        // segue para mensagens
      }
      router.push(userService.getRotaMensagens())
    },
  },
}
</script>

<style scoped>
.header-notificacoes-mobile {
  display: none;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 18px 16px;
  margin: 0;
  line-height: 1;
  cursor: pointer;
}

.notification-icon-wrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}

.notification-icon {
  width: 24px;
  height: 24px;
  display: block;
}

.notification-badge {
  position: absolute;
  z-index: 1;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background-color: #FF5364;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  box-sizing: border-box;
  pointer-events: none;
  border: 2px solid var(--bs-body-bg, #fff);
}

.notification-badge--total {
  top: -6px;
  right: -10px;
}

.notification-icon--muted {
  filter: grayscale(100%);
}

.notification-icon--pulse {
  animation: notification-icon-pulse-mobile 1.5s ease-in-out infinite;
}

@keyframes notification-icon-pulse-mobile {
  0%, 100% {
    filter: none;
    transform: scale(1);
  }
  50% {
    filter: drop-shadow(0 0 4px rgba(212, 23, 136, 0.55));
    transform: scale(1.06);
  }
}

@media (max-width: 991.98px) {
  .header-notificacoes-mobile {
    display: inline-flex;
  }
}

.header-notificacoes-mobile--app {
  display: inline-flex;
}
</style>
